import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M14 11c5.333 0 5.333-8 0-8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 11h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 15h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 21V3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 3h5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "RussianRuble";
const RussianRuble = memo(themed(Icon));
export {
  RussianRuble
};
//# sourceMappingURL=russian-ruble.js.map
